// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XControl_XComponent__HQBKU, .XControl_XControl__vgE4\\+ {
  margin-left: var(--margin-left);
  margin-right: var(--margin-right);
  margin-top: var(--margin-top);
  margin-bottom: var(--margin-bottom);
}`, "",{"version":3,"sources":["webpack://./src/X/components/commons/XComponent.module.scss","webpack://./src/X/components/commons/XControl.module.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;EACA,iCAAA;EACA,6BAAA;EACA,mCAAA;ACCJ","sourcesContent":[".XComponent {\r\n    margin-left: var(--margin-left);\r\n    margin-right: var(--margin-right);\r\n    margin-top: var(--margin-top);\r\n    margin-bottom: var(--margin-bottom);\r\n}",".XComponent, .XControl {\n  margin-left: var(--margin-left);\n  margin-right: var(--margin-right);\n  margin-top: var(--margin-top);\n  margin-bottom: var(--margin-bottom);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XComponent": `XControl_XComponent__HQBKU`,
	"XControl": `XControl_XControl__vgE4+`
};
export default ___CSS_LOADER_EXPORT___;
